<template>
  <div class="home">
    <div class="m-container">
      <home-carousel></home-carousel>
      <leadership-board></leadership-board>
      <!-- Virtual Games Platform -->
      <section class="virtual-games" id="virtual-games">
        <div class="virtual-games-content">
          <div class="row mb-20" v-for="item in competitions" :key="item.id">
            <div class="col-sm-6 col-md-6">
              <div class="content-holder">
                <h3>{{ item.name }}</h3>
                <div class="content-holder-text">
                  <div>
                    {{ item.short_description }}
                    <!-- <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laud antium, totam rem aperiam</p>
                    <p><i class="fa fa-check-square"></i> In tempor dui id lorem efficitur tempor.</p>
                    <p><i class="fa fa-check-square"></i> Morbi non pulvinar urna aliquet sapien.</p>
                    <p><i class="fa fa-check-square"></i> Nam tristique eu nunc sit pharetra.</p> -->
                  </div>
                  <!-- about us button -->
                  <div class="the-button">
                    <button class="wro-button secondaryButtons" @click="moreDetails(item.id,item.active)"
                            :disabled="item.active == 0">
                      <span>{{ item.active == 1 ? 'Read More' : 'Coming Soon' }}</span></button>
                    <span class="skew-line-w"></span>
                  </div>
                  <!-- about us button -->
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-md-6 img-holder">
              <img :src="item.image">
            </div>
          </div>
        </div>
      </section>
      <!-- end Virtual Games Platform -->
      <section class="virtual-games main-paragraphs" v-if="mainParagraphs.length > 0">
        <div class="virtual-games-content">
          <div class="row mb-20" v-for="item in mainParagraphs" :key="item.id">
            <div class="col-sm-12 col-md-6">
              <div class="content-holder">
                <h3>{{ item.title }}</h3>
                <div class="content-holder-text">
                  <div>
                    {{ item.description }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 img-holder">
              <img :src="item.image">
            </div>
          </div>
        </div>

      </section>
    </div>

    <!-- <testimonials></testimonials> -->
    
    <!-- <sponsors></sponsors> -->

    <contact-us></contact-us>
  </div>
</template>

<script>
import HomeCarousel from "@/components/home/HomeCarousel";
import LeadershipBoard from "@/components/home/LeadershipBoard";
import Competitions from "@/components/home/Competitions";
import CustomersFeedback from "@/components/home/CustomersFeedback";
import ContactUs from "../components/home/ContactUs";
import Button from "../components/tools/ButtonComponent";
import ButtonComponent from "../components/tools/ButtonComponent";
import Testimonials from "@/components/home/Testimonials";
// import Sponsors from "@/components/home/Sponsors";

export default {
  name: 'Home',
  data: () => ({
    competitions: [],
    mainParagraphs: []

  }),
  components: {ButtonComponent, Button, ContactUs, CustomersFeedback, Competitions, HomeCarousel, LeadershipBoard, Testimonials},
  methods: {
    redirectTo(e) {
      this.$router.replace(e);
    },
    moreDetails(competitions_id, competitions_status) {
      if (competitions_status == 1) this.$router.push({name: 'SelectedCompetitions', params: {id: competitions_id}});
      else return false;
    }
  },
  mounted() {
    this.$API.web.competitions.get_competitions()
        .then(response => {
          this.loading = false;
          this.competitions = response.data;
        })
        .catch(() => {

        });

    this.$API.general.getHomeParagraphs()
        .then(response => {
          this.mainParagraphs = response
        })

  }
}
</script>

<style>
.home {
  min-height: 100vh;
  position: relative;
  left: 0px;
  width: 100%;
  top: 0;
}

/****************************
** virtual-games style css
 *************/
.virtual-games .item {
  display: flex;
  justify-content: center;
  margin: 0px auto;
  margin-bottom: 22px;
}

.virtual-games .img-holder img {
  max-width: 200px;
}

.virtual-games .item-holder {
  display: flex;
}

.virtual-games .item-holder p:nth-child(1) {
  color: var(--mainColors);
  font-size: 2.4375rem;
}

.virtual-games .item-holder p:nth-child(2) {
  color: var(--secondaryColors);
  font-size: 0.6875rem;
  padding-left: 4px;
}

.virtual-games .item-holder .item-text {
  margin-left: 10px;
  width: 100%;
}

/***** virtual-games content text ****/

.virtual-games .virtual-games-content {
  margin: 100px 9%;
}

.virtual-games-content .content-holder {
  padding-top: 0px;
}

.virtual-games-content .content-holder h3 {
  font-size: 2.5rem;
  margin-bottom: 30px !important;
  color: #0A0443;
  font-weight: 500;
}

.virtual-games-content .content-holder-text {
  max-width: 416px;
}
.virtual-games-content .content-holder-text .the-button{ display: block; text-align: center;}
.virtual-games-content .content-holder-text .the-button .wro-button{ width: 205px; height: 60px; border-radius: 30px; box-shadow: none;}
.virtual-games-content .content-holder-text .the-button .wro-button span{ font-size: 1.245rem; font-weight: 500;}
.virtual-games-content .content-holder-text div:first-child {
  margin-bottom: 37px;
}

.virtual-games-content .content-holder-text > div {
  margin-bottom: 25px;
  color: #0A0443;
  font-weight: 400;
  font-size: 16px;
}

.virtual-games-content .content-holder-text > div p{ margin-bottom: 20px !important;}
.virtual-games-content .content-holder-text > div p .fa{ font-size: 20px; color: #0093D2; margin-right: 5px;}

.virtual-games-content .content-holder-text > div > a {
  color: var(--mainColors);
}
.virtual-games-content .row:nth-child(2){ flex-direction: row-reverse;}
.virtual-games-content .img-holder {
  display: flex;
  justify-content: center;
  align-items: center;
}

.main-paragraphs {
  border-top: 1px solid #DBE3EB;
}

.main-paragraphs img {
  max-width: 270px;
}

@media (max-width: 1079px) {
  .virtual-games .img-holder img { margin: auto;}

  .virtual-games .virtual-games-content { margin: 80px 50px;}
  .virtual-games-content .content-holder h3{font-size: 2rem; margin: 20px 0 !important;}
  .virtual-games-content .content-holder-text .the-button .wro-button{ width: 185px; height: 50px;}
}

@media (max-width: 767px) {
  .virtual-games .virtual-games-content{margin: 50px 0%;}  
  .virtual-games-content .img-holder{ width: 100%; margin: 15px 0;}
  .virtual-games-content .content-holder h3{margin: 0px 0 10px 0 !important; font-size:2rem;}
  .virtual-games-content .content-holder-text .the-button .wro-button{ width: 170px; height: 44px;}
}


@media (max-width: 465px) {
  .virtual-games .img-holder img {
    width: 100%;
  }
}

@media (max-width: 467px) {
  .virtual-games .item .item-holder .item-img img {
    width: 50px !important;
    height: 50px !important;
    position: relative;
    top: 10px;
  }
}

</style>